import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { getInitials } from 'utils/getInitials';
import { useShareDetailsPage } from '../context/ShareDetailsPageContext';

// import "./OwnershipCard.scss";

const OwnershipCard: FC = () => {
  const { t } = useTranslate();

  const { data } = useShareDetailsPage();
  const partnerName = data.partner?.name || '';
  const partnerEmail = data.partner?.email || '';

  const operationType = data.operation?.operationType || '';

  return (
    <div className="ownership-card bg-white">
      <p className="ownership-card__title">{t('Ownership')}</p>

      <div className="ownership-card__partner">
        <div className="ownership-card__avatar">{getInitials(partnerName)}</div>
        <div>
          <p className="ownership-card__name">{partnerName}</p>
          {partnerEmail && (
            <p className="ownership-card__email">{partnerEmail}</p>
          )}
        </div>
      </div>

      <dl className="ownership-card__meta">
        <dt>{t('Operation')}</dt>
        <dd className="ownership-card__meta-accent">{t(operationType)}</dd>

        <dt>
          {/* <em className="icon ni ni-tag" /> */}
          {t('Tag')}
        </dt>
        <dd>{data.tag || '-'}</dd>
      </dl>
    </div>
  );
};

export default OwnershipCard;
